import React from 'react'

export const ShopNow = () => (
  <svg width="24" height="24" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path
      d="M6.50005 9V4C6.50005 3.20435 6.81612 2.44129 7.37873 1.87868C7.94134 1.31607 8.7044 1 9.50005 1C10.2957 1 11.0588 1.31607 11.6214 1.87868C12.184 2.44129 12.5 3.20435 12.5 4V9M3.83105 6H15.17C15.4584 5.99997 15.7434 6.06229 16.0054 6.1827C16.2674 6.30311 16.5003 6.47876 16.6881 6.6976C16.8759 6.91645 17.0141 7.17331 17.0933 7.45059C17.1726 7.72786 17.1909 8.01898 17.147 8.304L15.892 16.456C15.7831 17.1644 15.4241 17.8105 14.88 18.2771C14.336 18.7438 13.6428 19.0002 12.926 19H6.07405C5.35745 19 4.66453 18.7434 4.12068 18.2768C3.57683 17.8102 3.21797 17.1643 3.10905 16.456L1.85405 8.304C1.81022 8.01898 1.82854 7.72786 1.90775 7.45059C1.98697 7.17331 2.12521 6.91645 2.31299 6.6976C2.50078 6.47876 2.73367 6.30311 2.99569 6.1827C3.25772 6.06229 3.54268 5.99997 3.83105 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
